import React, { Fragment, useState, useEffect } from "react";
import moment from "moment";
// import Button from "../../../component/button/Button";
import Starter from "../../../component/Starter";
import Card from "../../../component/card/Card";
import TextInput from "../../../component/input/TextInput";
import RenderToolTip from "../../../component/tooltip/RenderToolTip";
import { toolTipData } from "./leaveData";
import isEmpty from "../../../validation/isEmpty";
import { api } from "../../../apis";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";

import { helperFunction } from "../../../constant/helper";
import SelectInput from "../../../component/input/SelectInput";
import TextArea from "../../../component/input/TextArea";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import Button from "../../../component/button/Button";
import { hrActions } from "../../../redux/actions";
import { isSuperAdmin } from "../../../constant/helper/helper";

const initialState = {
  leaveTypeId: "",
  employeeId: "",
  workerId: "",
  leaveReason: "",
  numberOfDays: 0,
  leaveFrom: "",
  leaveTo: "",
  leaveStatus: "APPLIED",
  deviceName: "",
  createdByIp: "0.0.0.0",
  createdAtLocation: []
};

const AddLeave = () => {
  const dispatch = useDispatch();
  const loginType = localStorage.loginType;

  const [values, setValues] = useState(initialState);
  const [leaveType, setLeaveType] = useState([]);

  const { hrResponse, hrError, hrLoading } = useSelector(
    (state) => state.hr
  );

  const { currentUser } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isSuperAdmin(currentUser)) {
      setValues({ ...values, workerId: "" });
    } else {
      setValues({ ...values, workerId: currentUser.workerId });
    }
  }, [currentUser]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "leaveFrom") {
      const date1 = moment(value);
      const date2 = moment(values.leaveTo);
      const days = date2.diff(date1, "days");
      setValues({
        ...values,
        [name]: value,
        numberOfDays: String(Number(days) + 1)
      });
    } else if (name === "leaveTo") {
      const date1 = moment(values.leaveFrom);
      const date2 = moment(value);
      const days = date2.diff(date1, "days");
      setValues({
        ...values,
        [name]: value,
        numberOfDays: String(Number(days) + 1)
      });
    } else {
      setValues({
        ...values,
        [name]: value
      });
    }
  };

  useEffect(() => {
    if (!isEmpty(localStorage.cmcAttendanceJwtToken)) {
      (async () => {
        const { baseUrlNode } = await helperFunction.checkLoginType(
          loginType
        );
        const url = `${baseUrlNode}${api.Hr_Api.GET_LEAVE_TYPE_API}`;
        const leaveTypeList = await axios.get(url);
        const { foundLeave } = leaveTypeList.data;

        setLeaveType(foundLeave);
      })();
    }
    dispatch(hrActions.setHrLoading(false));
    dispatch(hrActions.clearHrErrors());
    dispatch(hrActions.clearHrResult());

    return () => {
      dispatch(hrActions.setHrLoading(false));
      dispatch(hrActions.clearHrErrors());
      dispatch(hrActions.clearHrResult());
    };
  }, []);

  useEffect(() => {
    if (hrError) {
      helperFunction.toastHelper("error", hrError);
    }
    if (hrResponse) {
      helperFunction.toastHelper("success", hrResponse);
    }
  }, [hrError, hrResponse]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const leaveId = "applyLeave";
    const leaveData = {
      ...values,
      leaveStatus: "APPLIED",
      createdAtLocation: [
        localStorage.getItem("latitude"),
        localStorage.getItem("longitude")
      ],
      createdByIp: localStorage.getItem("publicIpAdd"),
      browserDetails: localStorage.getItem("browserDetails")
    };

    dispatch(hrActions.setHrLoading(true));
    dispatch(hrActions.clearHrErrors());
    dispatch(hrActions.clearHrResult());
    dispatch(
      hrActions.applyLeaveAction(leaveData, leaveId, loginType)
    );
  };

  return (
    <Starter
      topBarTitle="Apply Leave"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">HR Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">HR</a>
          </li>
          <li className="breadcrumb-item active">Apply Leaves</li>
        </Fragment>
      }
    >
      <RenderToolTip toolTipData={toolTipData} />
      <Card>
        <form onSubmit={handleSubmit}>
          <div className="row mb-2">
            <div className="col-md-3  col-xl-3 col-lg-3">
              <TextInput
                type="text"
                name="workerId"
                required={true}
                textWhite={false}
                htmlFor="workerId"
                label="Employee-Id"
                value={values.workerId}
                onChange={handleInputChange}
                placeholder="Enter Employee-Id"
                disabled={!isSuperAdmin(currentUser)}
              />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <TextInput
                data-tip
                type="date"
                name="leaveFrom"
                label="Leave From"
                data-for="leaveFrom"
                value={values.leaveFrom}
                onChange={handleInputChange}
                icon="mdi mdi-calendar-check"
                placeholder="Select from Date"
              />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <TextInput
                data-tip
                type="date"
                name="leaveTo"
                label="Leave To"
                data-for="leaveTo"
                value={values.leaveTo}
                onChange={handleInputChange}
                icon="mdi mdi-calendar-check"
                placeholder="Select from Date"
              />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <TextInput
                data-tip
                type="text"
                name="numberOfDays"
                label="Number Of Days"
                data-for="numberOfDays"
                value={values.numberOfDays}
                onChange={handleInputChange}
                disabled={true}
                icon="mdi mdi-calendar-check"
                placeholder="Enter Number of days"
              />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <SelectInput
                required={true}
                textWhite={false}
                isLabeled={false}
                name="leaveTypeId"
                label="Select Leave Type"
                value={values.leaveTypeId}
                onChange={handleInputChange}
              >
                <option value=""> Select Leave Type</option>

                {leaveType.map((leaveData, leaveIndex) => (
                  <option value={leaveData._id} key={leaveIndex}>
                    {leaveData.leaveName}
                  </option>
                ))}
              </SelectInput>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-12">
              <TextArea
                row={8}
                type="text"
                required={true}
                textWhite={false}
                name="leaveReason"
                htmlFor="leaveReason"
                label="Write a Reason"
                value={values.leaveReason}
                placeholder="Enter Reason"
                onChange={handleInputChange}
              />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="mt-2">
                {hrLoading ? (
                  <SpinnerButton />
                ) : (
                  <Button
                    type="submit"
                    title="Submit"
                    isBackgroundColor={false}
                    icon="mdi mdi-plus-circle-outline mr-2"
                    className="btn text-white btn-block btn-dark"
                  />
                )}
              </div>
            </div>
          </div>
        </form>
      </Card>
    </Starter>
  );
};

export default AddLeave;
